import { usingPost, usingGet } from '@ocean/api'

export const startSimulatorExerciseSession = (scheduleId: Guid) =>
  usingPost(`SimulatorTrainings/StartSimulatorExerciseSession`, { scheduleId })

export const getSimulatorExerciseUserSchedule = (scheduleId: Guid) =>
  usingGet(`SimulatorTrainings/studentLed/schedules/${scheduleId}`, { useProxy: true })
